<template>
  <section class="section">
    <h1>{{ $t('translators.title') }}</h1>
    <p>{{ $t('translators.subtitle') }}</p>

    <div class="translator-grid">
      <transition-group name="fade" tag="div" class="card-wrapper">
        <TranslatorCard
          v-for="translator in translators"
          :key="translator.id"
          :name="translator.name"
          :photo="getPhotoUrl(translator.avatar)"
          :languages="formatLanguages(translator.languages)"
          :university="translator.university"
        />
      </transition-group>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import TranslatorCard from '@/components/TranslatorCard.vue'

const translators = ref([])
const baseURL = process.env.VUE_APP_API_URL

function getPhotoUrl(photoPath) {
  return photoPath?.startsWith('http')
    ? photoPath
    : `${baseURL}/uploads/avatar/${photoPath || 'default-avatar.png'}`
}

function formatLanguages(lang) {
  if (typeof lang === 'string') return lang
  if (Array.isArray(lang)) return lang.join(', ')
  return ''
}

onMounted(async () => {
  try {
    const res = await axios.get(`${baseURL}/public/featured-translators`)
    translators.value = res.data
  } catch (err) {
    console.error('Tercümanlar alınamadı:', err)
  }
})
</script>

<style scoped>
.section {
  min-height: 100vh;
  padding: 60px 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #f9f9f980;
}

.translator-grid {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 30px;
  margin-top: 40px;
}

.card-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
}

.fade-enter-active, .fade-leave-active {
  transition: all 0.6s ease;
}
.fade-enter-from {
  opacity: 0;
  transform: translateY(30px);
}
.fade-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
@media (max-width: 768px) {
  .section {
    padding: 40px 15px;
  }

  .translator-grid,
  .card-wrapper {
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }

  .card-wrapper > * {
    width: 90%;
  }
}

</style>
